module.exports = __webpack_public_path__ + "img/home.2c308035.png";